import Swal from 'sweetalert2'

// HttpManager.js
class HttpManager {

  constructor(navigate) {
    this.navigate = navigate;
  }

  // Base URL for the API (you can change this to your backend URL)
  baseUrl = process.env.REACT_APP_DECIPHERX_API_URL; //"https://api.decipherx.in"; //'https://localhost:7231/api';

  // Function to handle GET requests
  async get(endpoint) {
    let response;
    try {
      response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'GET',
        credentials: "include", // This ensures cookies are sent with the request
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 401) {

          // Clear localStorage
          localStorage.removeItem('User');

          // Dispatch logout event to update <Header />
          window.dispatchEvent(new Event('logout'));

          // Show a SweetAlert2 popup for unauthorized access
          Swal.fire({
            icon: 'error',
            title: 'Unauthorized',
            text: 'Login Expired. Please login again.',
            confirmButtonText: 'OK'
          }).then(() => {
            this.navigate('/Login');
          });
        }
        else
          throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      if (text)
        return JSON.parse(text);
      return null; // Return null if no text is received
    } catch (error) {
      // Handle the error here (e.g., show a notification or log it)
      if (response.status !== 401) {
        console.error('POST request failed:', error);
        throw error;
      }
    }
  }

  // Function to handle POST requests
  async post(endpoint, body) {
    let response;
    try {
      response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'POST',
        credentials: "include", // This ensures cookies are sent with the request
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        if (response.status === 401) {

          // Clear localStorage
          localStorage.removeItem('User');

          // Dispatch logout event to update <Header />
          window.dispatchEvent(new Event('logout'));

          Swal.fire({
            icon: 'error',
            title: 'Unauthorized',
            text: 'Login Expired. Please login again.',
            confirmButtonText: 'OK'
          }).then(() => {
            this.navigate('/Login');
          });
        }
        else
          throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      if (text)
        return JSON.parse(text);
      return null; // Return null if no text is received

    } catch (error) {
      // Handle the error here (e.g., show a notification or log it)
      if (response.status !== 401) {
        console.error('POST request failed:', error);
        throw error;
      }
    }
  }
}

export default HttpManager;
